(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artro-v3-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    const initNav = (root) => {
      if (!root || root.dataset.artroV3NavInit === 'true') return;

      const toggle = root.querySelector('[data-artro-v3-mobile-toggle]');
      const overlay = root.querySelector('[data-artro-v3-mobile-overlay]');
      const panel = root.querySelector('[data-artro-v3-mobile-panel]');
      const closeButtons = root.querySelectorAll(
        '[data-artro-v3-mobile-close], [data-artro-v3-mobile-backdrop], [data-artro-v3-mobile-link]'
      );
      const productMenu = root.querySelector('[data-artro-v3-products-menu]');

      if (!toggle || !overlay || !panel) return;

      root.dataset.artroV3NavInit = 'true';

      const syncScrollState = () => {
        root.classList.toggle('is-scrolled', window.scrollY > 8);
      };

      const closeProductsMenu = () => {
        if (productMenu && productMenu.open) {
          productMenu.removeAttribute('open');
        }
      };

      const setOpen = (isOpen) => {
        toggle.setAttribute('aria-expanded', String(isOpen));
        overlay.setAttribute('aria-hidden', String(!isOpen));
        overlay.classList.toggle('pointer-events-none', !isOpen);
        overlay.classList.toggle('opacity-0', !isOpen);
        overlay.classList.toggle('opacity-100', isOpen);
        panel.classList.toggle('translate-x-full', !isOpen);
        panel.classList.toggle('translate-x-0', isOpen);
        document.body.classList.toggle('artro-v3-nav-open', isOpen);
      };

      toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
      window.addEventListener('scroll', syncScrollState, { passive: true });
      syncScrollState();

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          setOpen(false);
          closeProductsMenu();
        }
      });

      document.addEventListener('click', (event) => {
        if (!productMenu || !productMenu.open) return;
        if (productMenu.contains(event.target)) return;
        closeProductsMenu();
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-artro-v3-nav-root]').forEach(initNav);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
